import VConsole from 'vconsole';
import Vue from 'vue';
import VueRx from 'vue-rx';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import { isMobile } from 'mobile-device-detect';
import App from './App.vue';
import router from './route/router';
import store from './store';

import i18n from './locales/i18n';
import filter from './filters/filter';
import Loader from './plugins/loader/loader';
import './plugins/simple-popup';

import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/css/te-cutsom.min.css';
import '@/assets/css/te-mcf.css';

// 查詢參數
const urlParams = new URLSearchParams(window.location.search);

// 啟用VConsole協助Debug
if (urlParams.get('console')) {
  /* eslint-disable no-new */
  new VConsole();
}
Vue.use(BootstrapVue);
Vue.use(VueRx);
Vue.use(Loader);

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

store.state.isMobile = isMobile;

// 在app啟用時計算一次viewport高度
if (isMobile) {
  let vh = document.documentElement.clientHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  window.addEventListener('resize', () => {
    vh = document.documentElement.clientHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
}

new Vue({
  router,
  store,
  i18n,
  filter,
  render: (h) => h(App),
}).$mount('#app');
